import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class PropertyCodeLookupService {
    static getPropertyCodes(
        lob,
        jobNumber,
        previousClassCode,
        address,
        sessionUUID,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayPropertyCodeLookup'),
            'getPropertyCodes',
            [lob, jobNumber, previousClassCode, address, sessionUUID],
            additionalHeaders
        );
    }
}
